import { LocationType } from '~/client/graph/types.generated'

import { enumToList } from '../utils/converters'

const locationTypesList = enumToList(LocationType)

export default locationTypesList
